import React, { PropTypes } from 'react';

const CardHeader = ({ children, className }) => {
    return (
        <div className={`card-header${className ? ` ${className}` : ''}`}>
            {children}
        </div>
    );
};

CardHeader.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string
};

export default CardHeader;


/** WEBPACK FOOTER **
 ** ./src/components/bootstrap/CardHeader.js
 **/